import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Tag: FC<IIconsProps> = ({ color, size = IconScale.M }: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.8299 11.6616L11.3533 20.6643C11.1567 20.8511 10.8471 20.8471 10.6554 20.6554L3.35355 13.3536C3.15829 13.1583 3.15829 12.8417 3.35355 12.6464L12.3405 3.65955C12.4419 3.55811 12.582 3.50513 12.7252 3.51407L20.0615 3.9726C20.3123 3.98827 20.5125 4.18764 20.5292 4.43836L20.9844 11.2659C20.9943 11.4142 20.9377 11.5592 20.8299 11.6616Z"
        stroke={color}
        strokeWidth="2"
      />
      <circle cx="14.5" cy="9.5" r="2.5" stroke={color} strokeWidth="2" />
    </svg>
  );
};

export default Tag;
